
import { PricingTable } from "@/components/landing/PricingTable";

export const LandingPricing = () => {
    return (
        <section id="pricing" className="py-24 bg-gray-50">
            <div className="container mx-auto px-4">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Pricing that makes sense.
                    </h2>
                    <p className="text-gray-500 text-lg">
                        Start for free, upgrade when you grow.
                    </p>
                </div>

                <PricingTable />
            </div>
        </section>
    );
};
